module.exports = __webpack_public_path__ + "img/undraw_towing_6yy4.dd93c6c5.svg";